import { Shield, Users, Target, Heart, ArrowLeft } from "lucide-react";
import "../styles/AboutPage.css";
import { Link } from "react-router-dom";

export default function AboutPage() {
  const team = [
    { name: "Emmanuel Adjanohoun", role: "Fondateur & CEO", bio: "10 ans d'expérience dans la tech" },
    { name: "Ange Assemou", role: "Ingénieur Logiciel", bio: "Spécialiste en IoT et sécurité" },
    { name: "Kouagnikan Arnaud", role: "Directeur Marketing", bio: "Expert en croissance digitale" },
    { name: "Delphine Ouangré", role: "Responsable Support", bio: "Passionnée par le service client" },
  ];

  return (
    <div className="about-page">
      <section className="about-hero">
        <div className="container">
        <Link to="/" className="privacy-back-button">
          <ArrowLeft size={20} />
          Retour à l'accueil
        </Link>
          <h1>Notre histoire</h1>
          <p>Protéger vos objets importants avec une technologie simple et efficace</p>
        </div>
      </section>

      <section className="mission-section">
        <div className="container">
          <h2>Notre mission</h2>
          <p className="mission-text">
            Chez UltimaTag, nous croyons que la tranquillité d'esprit ne devrait pas être un luxe. 
            Notre mission est de créer des solutions innovantes pour protéger ce qui compte vraiment 
            pour vous, grâce à une technologie accessible et une communauté solidaire.
          </p>
          
          <div className="values-grid">
            <div className="value-card">
              <div className="value-icon">
                <Shield size={32} />
              </div>
              <h3>Sécurité</h3>
              <p>Protection supplémantaire , un dernier espoir de retrouver vos objets</p>
            </div>

            <div className="value-card">
              <div className="value-icon">
                <Users size={32} />
              </div>
              <h3>Communauté</h3>
              <p>Un réseau solidaire prêt à aider à retrouver vos objets</p>
            </div>

            <div className="value-card">
              <div className="value-icon">
                <Target size={32} />
              </div>
              <h3>Innovation</h3>
              <p>Technologie simple mais puissante au service de tous</p>
            </div>

            <div className="value-card">
              <div className="value-icon">
                <Heart size={32} />
              </div>
              <h3>Service</h3>
              <p>Support réactif et humain à chaque étape</p>
            </div>
          </div>
        </div>
      </section>

      <section className="team-section">
        <div className="container">
          <h2>Notre équipe</h2>
          <p>Des passionnés réunis par une vision commune</p>
          
          <div className="team-grid">
            {team.map((member, index) => (
              <div key={index} className="team-card">
                <div className="team-avatar">
                  <div className="avatar-placeholder">
                    {member.name.split(' ').map(n => n[0]).join('')}
                  </div>
                </div>
                <h3>{member.name}</h3>
                <p className="team-role">{member.role}</p>
                <p className="team-bio">{member.bio}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="stats-section">
        <div className="container">
          <div className="stats-grid">
            <div className="stat-item">
              <div className="stat-number">100+</div>
              <div className="stat-label">Utilisateurs satisfaits</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">98%</div>
              <div className="stat-label">Taux de satisfaction</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">24h</div>
              <div className="stat-label">Support réactif</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">1000+</div>
              <div className="stat-label">Objets protégés</div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}